export default __webpack_public_path__ + "static/media/light_desktop.12b41e93.png";